import type { PropsWithChildren } from 'react';
import { Navigate, Route } from 'react-router';
import { useTransparencyReportingAuthorization } from 'src/apis/transparency-reporting/use-transparency-reporting-authorization';
import { ThrowNotFound } from 'src/components/feedback/not-found';
import { PageHeader } from 'src/components/layout/page-header';
import { Link } from 'src/components/navigation/link';
import { Tabs } from 'src/components/navigation/tabs';
import { RootRoutes } from 'src/components/root-routes';
import { PageSpinner } from 'src/components/spinner-container';
import { JobsOverview } from 'src/pages/reporting/transparency-reporting/jobs/overview';
import { ReportsDetails } from 'src/pages/reporting/transparency-reporting/reports/details';
import { ReportsOverview } from 'src/pages/reporting/transparency-reporting/reports/overview';
import { Forbidden } from 'src/utils/errors';

export const TransparencyReporting = () => {
  const authorization = useTransparencyReportingAuthorization();

  if (!authorization.response) return <PageSpinner />;

  if (authorization.response.data.canView !== true) throw new Forbidden();

  return (
    <RootRoutes>
      <Route
        path="/reporting/tr"
        element={<Navigate replace to="/reporting/tr/job-run" />}
      />

      <Route
        path="/reporting/tr/job-run"
        element={
          <TransparencyReportingNavigationView>
            <ReportsOverview />
          </TransparencyReportingNavigationView>
        }
      />
      <Route
        path="/reporting/tr/jobs"
        element={
          <TransparencyReportingNavigationView>
            <JobsOverview authorization={authorization.response.data} />
          </TransparencyReportingNavigationView>
        }
      />

      <Route
        path="/reporting/tr/job-run/:id"
        element={<ReportsDetails authorization={authorization.response.data} />}
      />

      <Route path="*" element={<ThrowNotFound />} />
    </RootRoutes>
  );
};

const TransparencyReportingNavigationView = ({
  children,
}: PropsWithChildren) => (
  <div className="grid items-center gap-md">
    <PageHeader title="Transparency Reporting" />

    <div className="grid items-center gap-xl">
      <Tabs>
        <Link to="/reporting/tr/job-run">Reports</Link>
        <Link to="/reporting/tr/jobs">Jobs</Link>
      </Tabs>

      {children}
    </div>
  </div>
);
